(ns pfo.collection.model
  (:require
   [promesa.core :as p]
   [pfo.collection.spec :as spec]
   [malli.core :as m]
   [pfo.util :as util :refer [bool-param]]
   [pfo.state :as state]
   [pfo.api :as api]))

(defn collection-key [collection] (str "collection-" (:id collection)))

(defn collection-name [col]
  [:span (when-not (:active col) {:class :u-strikethrough}) (:name col)])

(defn is-group [collection] (= "gr" (:type collection)))

(defn has-document-automation-enabled [family-id] (get-in @state/family-settings [:document_automation_enabled (util/str->int family-id)]))

(defn has-boir-efile-enabled [family-id] (get-in @state/family-settings [:boir_efile_enabled (util/str->int family-id)]))

(defn has-report-mode-enabled [family-id] (get-in @state/family-settings [:report_mode_enabled (util/str->int family-id)]))

(defn has-collection-chart-enabled [family-id] (get-in @state/family-settings [:collection_chart_enabled (util/str->int family-id)]))

(defn has-aark-enabled [family-id] (get-in @state/family-settings [:aark_enabled (util/str->int family-id)]))

(defn has-aark-enabled-in-any-family []
  (boolean
   (some true? (vals (:aark_enabled @state/family-settings)))))

(defn has-collection-review-enabled [family-id] (get-in @state/family-settings [:collection_review_enabled (util/str->int family-id)]))

;; Fail open, like the mobile gate: chat goes away only when the flag arrived
;; for the user's families and every one of them is off. A session that cached
;; family-settings before the flag existed keeps its chat icon.
(defn chat-disabled-in-every-family []
  (let [flags (vals (:chat_enabled @state/family-settings))]
    (and (seq flags) (every? false? flags))))

(defn can-be-chart-subject? [collection]
  (-> collection :collection_type :chart_subject))
(m/=> can-be-chart-subject? [:=> [:cat spec/collection-with-type] :any])

(defn collection-search [parent-id disabled-ids include-inactive filter-fn aname cb]
  (if (and (string? aname) (not-empty aname))
    (api/ajax "/search/collections/"
              {:params (into {} (util/remove-nil-values
                                 {:name aname
                                  :parent_id parent-id
                                  :include_inactive (if include-inactive "yes" "no")}))}
              (fn [response]
                (cb (clj->js (for [entry response
                                   :let [parent-trail (get-in entry [:parent_trail])
                                         parent-trail (if (vector? parent-trail)
                                                        parent-trail [parent-trail])
                                         fields (:fields entry)]
                                   :when (and
                                          (not (contains? disabled-ids (js/parseInt (:id fields))))
                                          (or (not filter-fn) (filter-fn entry)))]
                               {:value (:id fields)
                                :label (:name fields)
                                :listLabel [:span (:name fields)
                                            (when (> (count parent-trail) 1)
                                              [:span [:br] [:span.parent-trail-desc "Inside: "]
                                               [:span.parent-trail (clojure.string/join " / " (butlast parent-trail))]])]
                                :ancestorNames parent-trail}))))

              (fn [response] (println "failed to fetch collections" response)))

    (cb nil [])))


(defn collection-list [parent-id cb]
  (api/ajax "/collections/" {:params {:parent_id (or parent-id "")}} cb))

(defn ^{:deprecated "Use :collection-list controller instead"} collection-list-promise [parent-id include-intermediate]
  (api/ajaxp "/collections/" {:params (util/remove-nil-values {:parent_id parent-id
                                                               :include_intermediate include-intermediate})}))

(defn sortable-collection-list
  ([collection-ids page order page-size]
   (api/ajaxp "/list/collections/?" {:body (util/make-params (util/remove-nil-values
                                                              {:collection_id collection-ids
                                                               :page page
                                                               :order order
                                                               :page_size page-size}))
                                     :method :post}))
  ([collection-ids page order]
   (sortable-collection-list collection-ids page order nil)))

(defn family-collection-list
  ([family-id page order include-dispositions disposition-uid collection-name label-ids page-size]
   (api/ajaxp "/list/collections/?" {:body (util/make-params (util/remove-nil-values
                                                              {:collection_id family-id
                                                               :include_subcollections true
                                                               :page page
                                                               :order order
                                                               :include_dispositions include-dispositions
                                                               :disposition_uid disposition-uid
                                                               :collection_name collection-name
                                                               :label_id (vec label-ids)
                                                               :page_size page-size}))
                                     :method :post}))
  ([family-id page order include-dispositions disposition-uid collection-name label-ids]
   (family-collection-list family-id page order include-dispositions disposition-uid collection-name label-ids nil)))

(defn collection-tree
  ([parent-id include-self include-inactive filter-options]
   (api/ajaxp
    "/tree/collections/"
    {:params (util/remove-nil-values (merge
                                      {:parent_id (or parent-id "")
                                       :include_self (if include-self "yes" "no")
                                       :include_inactive (if include-inactive "yes" "no")}
                                      filter-options))
     :disable-loadin-counter (boolean filter-options)}))
  ([parent-id include-self include-inactive] (collection-tree parent-id include-self include-inactive nil))
  ([parent-id] (collection-tree parent-id true false)))

(defn collection-details [id]
  (api/ajaxp (str "/collections/" id "/") {}))

(defn collection-full-details
  ([id disable-loadin-counter]
   (api/ajaxp (str "/collections/" id "/") {:params {:full "1"}
                                            :disable-loadin-counter disable-loadin-counter}))
  ([id]
   (collection-full-details id false)))

(defn collection-ancestors [id]
  (api/ajaxp (str "/collections/" id "/ancestors/") {}))

(defn to-search-obj
  "converts collection object to a native object of the search widget"
  [collection]
  {:value (:id collection) :label (collection-name collection) :plainLabel (:name collection) :listLabel (:name collection) :ancestorNames (mapv #(:name %) (:ancestors collection))})

(defn permitted-users
  ([{include-contacts :include-contacts
     regular-only :regular-only
     include-subcollections :include-subcollections
     include-emails :include-emails
     exclude-root :exclude-root
     task-assign :task-assign
     compliance-assign :compliance-assign event-invite :event-invite
     document-view :document-view
     :as options} collection-ids]
   (api/ajaxp (str "/permitted_users/?" (util/make-params {:collection_id collection-ids
                                                           :include_subcollections (bool-param include-subcollections)
                                                           :include_contacts (bool-param include-contacts)
                                                           :include_emails (bool-param include-emails)
                                                           :exclude_root_collections (bool-param exclude-root)
                                                           :regular_only (bool-param regular-only)
                                                           :task_assign (bool-param task-assign)
                                                           :compliance_assign (bool-param compliance-assign)
                                                           :event_invite (bool-param event-invite)
                                                           :document_view (bool-param document-view)})) {}))
  ([collection-ids] (permitted-users collection-ids false)))

(defn permitted-groups [collection-id]
  (api/ajaxp "/permitted_groups/"
             {:params (util/remove-nil-values {:collection_id collection-id})}))

(defn permitted-subscriber-groups [subscriber-id]
  (api/ajaxp "/permitted_groups/"
             {:params (util/remove-nil-values {:subscriber_id subscriber-id})}))

(defn role-list []
  (api/ajaxp "/roles/" {}))

(def boir-collection-type-refs
  #{"llc"
    "partnership"
    "s_corporation"
    "c_corporation"
    "family_trust_company"})

(def trust-collection-type-refs
  #{"revocable_trust"
    "irrevocable_trust"
    "grat"
    "irrevocable_grantor_trust"
    "irrevocable_trust_esbt"
    "irrevocable_trust_qsst"
    "irrevocable_life_insurance_trust"})

(defn is-boir-collection [col]
  (contains? boir-collection-type-refs (get-in col [:collection_type :ref])))
(m/=> is-boir-collection [:=> [:cat spec/collection-with-type] :any])

(defn is-trust-collection [col]
  (contains? trust-collection-type-refs (get-in col [:collection_type :ref])))
(m/=> is-trust-collection [:=> [:cat spec/collection-with-type] :any])

(defn boir-preview [collection-id filing-type type]
  (api/ajaxp (str "/boir/preview/" collection-id) {:params (util/remove-nil-values {:filing_type filing-type :type type})}))

(defn aark-enabled-only [families aark-enabled]
  (if aark-enabled
    (filter #(= true (:aark_enabled %)) families)
    families))

;; A family from a server that predates the chat flag has no :chat_enabled key,
;; so only an explicit false removes it. This matches the mobile gate.
(defn chat-enabled-only [families]
  (remove #(= false (:chat_enabled %)) families))
